const STORAGE_KEY = "sg_signup_ref";
const FIRST_TOUCH_COOKIE = "sg_ft";
const NEW_SIGNUP_WINDOW_MS = 10 * 60 * 1000;

// Google/LinkedIn sign-in redirects drop query params, so keep them before leaving the page.
export function storeSignupRefFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  if (!params.get("ref")) return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ref: params.get("ref"),
        ref_page: params.get("ref_page"),
        ref_cta: params.get("ref_cta"),
      })
    );
  } catch (_) {
    // Ignore storage errors (private browsing, storage full)
  }
}

export function clearSignupRef() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // Ignore storage errors
  }
}

function readStoredRef() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (_) {
    return {};
  }
}

// Set by the marketing site on .supergrow.ai; absent on localhost and staging.
function readFirstTouch(cookie = document.cookie) {
  const match = cookie.match(new RegExp(`(?:^|; )${FIRST_TOUCH_COOKIE}=([^;]*)`));
  if (!match) return {};
  try {
    return JSON.parse(decodeURIComponent(match[1])) || {};
  } catch (_) {
    return {};
  }
}

export function getSignupAttribution(cookie = document.cookie) {
  const ref = readStoredRef();
  const ft = readFirstTouch(cookie);
  return {
    first_landing_page: ft.landing_page ?? null,
    first_source: ft.source ?? "unknown",
    first_medium: ft.medium ?? "unknown",
    first_campaign: ft.campaign ?? null,
    signup_ref: ref.ref ?? "direct",
    signup_ref_page: ref.ref_page ?? null,
    signup_ref_cta: ref.ref_cta ?? null,
  };
}

// confirmed_at, not created_at: email users can click the confirmation link hours after signUp.
export function isNewSignup(user, now = Date.now()) {
  if (!user || user.user_metadata?.signup_tracked_at) return false;
  const confirmedAt = Date.parse(user.confirmed_at || user.created_at);
  return now - confirmedAt < NEW_SIGNUP_WINDOW_MS;
}
